import classNames from 'classnames'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import styles from './content.module.scss'
import { Spinner } from '@components/spinner'
import type { AnimationStatus } from '@lib/hooks/useAnimation'

export const ButtonContent = forwardRef<
    HTMLDivElement,
    PropsWithChildren<Props>
>(({ animationStatus, loading, children }, ref) => (
    <>
        {animationStatus !== 'playing' && loading ? (
            <Spinner size='medium' />
        ) : (
            animationStatus !== 'playing' && children
        )}
        <div
            ref={ref}
            className={classNames(
                styles.animation,
                animationStatus && styles[`animation-${animationStatus}`],
            )}
        />
    </>
))

interface Props {
    animationStatus?: AnimationStatus
    loading?: boolean
}
